export const ACCESS_TOKEN = 'accessToken';

export const COLORS = {
  WHITE: '#ffffff',
  GRAY100: '#D0D5DD',
  SECONDARY: '#5532FA',
  SUCCESS: '#49BC80',
};

export const NETWORK_ERROR = 'Network Error';
export const ERROR_STATUS_500 = 5;
export const ERROR_STATUS_401 = 401;
export const ERROR_STATUS_404 = 404;
export const ERROR_MESSAGE = 'Something went wrong!';

export const FIELD_TYPES = {
  UPLOAD: 'upload',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  FILE: 'file',
  TEL: 'tel',
  EMAIL: 'email',
  TEXTAREA: 'textarea',
  DATE: 'date',
  CONSENT: 'consent',
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const MAX_LENGTH_LIMIT = 100;

export const DELETED = 'DELETED';

export const MOBILE_BREAKPOINT = 576;

export const DATE_FORMAT = {
  STANDARD_TIME: 'HH:mm',
  RANGE_DATE: 'DD/MM/YYYY',
  STANDARD_DATE: 'YYYY-MM-DD',
};

export const RESET = 'reset';

export const CLOSE = 'close';

export const ENTER = 'Enter';

export const PRIMITIVE_TYPES = {
  STRING: 'string',
  OBJECT: 'object',
  NUMBER: 'number',
};

export const POPOVER_HEIGHT = 320;

export const DROP_DOWN = 'DROPDOWN';
export const UPLOAD = 'UPLOAD';
export const TEXT_AREA = 'TEXTAREA';
export const DATE_TYPE = 'DATE';
export const NUMBER = 'NUMBER';
export const EMAIL = 'EMAIL';
export const CONSENT = 'CONSENT';

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const GRADIENT_DIRECTIONS = [{ label: 'VERTICAL' }, { label: 'HORIZONTAL' }];

export const GRADIENT_DIRECTION_MAP = {
  VERTICAL: 'to bottom',
  HORIZONTAL: 'to right',
};

export const FONT_WEIGHTS = {
  BOLD: 700,
  REGULAR: 400,
};

export const APPEARANCE_BACKGROUND_TABS = {
  SOLID: 'SOLID',
  GRADIENT: 'GRADIENT',
  IMAGE: 'IMAGE',
};

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const TRIGGER_MODE = {
  TIMER: 'TIMER',
  EXIT_INTENT: 'EXIT_INTENT',
};

export const EXIT_INTENT = {
  SUPPORT_PARAM: 'exit',
  SUPPORT_VERSION: '1',
  MESSAGE_TYPE: 'EXIT_INTENT',
};

export const SECOND_MS = 1000;
export const SUBMIT_SUCCESS_CLOSE_DELAY_MS = 2 * SECOND_MS;

export const POPUP_LAYOUT_DEFAULTS = {
  LAYOUT_MODE: 'IMAGE_LEFT',
  IMAGE_WIDTH_PERCENT: 50,
  MAX_WIDTH: 1000,
};

export const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'fi', label: 'FI' },
  { code: 'sv', label: 'SV' },
  { code: 'de', label: 'DE' },
];

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'fi', label: 'Suomi' },
  { value: 'sv', label: 'Svenska' },
  { value: 'de', label: 'Deutsch' },
];
